import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { __rest as n } from "../_virtual/_tslib.js";
import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { Fonts as t } from "@vds-core/typography";
import { calculateRem as o, withVDSManager as r } from "@vds-core/utilities";
import { AccessibilityTokens as a } from "@vds-tokens/accessibility";
import { ColorTokens as l } from "@vds-tokens/color";
import { LayoutTokens as c } from "@vds-tokens/layout";
import { TypographyTokens as s } from "@vds-tokens/typography";
import d, { css as u } from "styled-components";
var p = e("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.6 21.6",
    children: e("path", {
      d: "M14.1,20.7l-9.9-9.9l9.9-9.9l2.5,2.5l-7.3,7.3l7.3,7.3L14.1,20.7z"
    })
  }),
  f = e("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.6 21.6",
    children: e("path", {
      d: "M7.6,20.7L5,18.1l7.3-7.3L5,3.5l2.5-2.5l9.9,9.9L7.6,20.7z"
    })
  }),
  h = l.elements.primary.onlight.value,
  v = l.elements.primary.ondark.value,
  g = l.interactive.disabled.onlight.value,
  $ = l.interactive.disabled.ondark.value,
  m = a.color.focusring.onlight.value,
  b = a.color.focusring.ondark.value,
  y = s.fontweight.bold.value,
  x = s.fontsize.body[16].value,
  w = s.fontsize.body[16].value,
  k = s.lineheight.body[20].value,
  S = s.lineheight.body[20].value,
  C = "0.35s",
  I = "cubic-bezier(0.22, 0.61, 0.36, 1.0)",
  V = o(44),
  _ = o(c.space["1X"].value),
  z = a.focusring.borderwidth.value,
  L = a.focusring.space.offset.value,
  G = o(12),
  A = "calc(100% + ".concat(o(parseInt(L, 10)), ")"),
  D = function D(n) {
    return "dark" === n ? l.interactive.active.ondark.value : l.interactive.active.onlight.value;
  },
  R = d.span.withConfig({
    displayName: "Wrapper",
    componentId: "VDS__sc-o7am1d-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: inline-flex;\n  &:focus {\n    outline: none;\n  }\n"]))),
  P = d.a.withConfig({
    displayName: "StyledAnchor",
    componentId: "VDS__sc-o7am1d-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-content: center;\n  align-items: ", ";\n  background-color: transparent;\n  background-image: none;\n  border: 0;\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-size: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  position: relative;\n  text-decoration: none;\n  touch-action: manipulation;\n  width: fit-content;\n  pointer-events: auto; /* to ensure this click event works when used in a TileContainer */\n  -webkit-tap-highlight-color: transparent;\n\n  * {\n    pointer-events: none; /* pointer-events is added here to ensure the correct item is returned by the onclick handler */\n    outline: none;\n  }\n\n  &:active {\n    outline: none;\n    color: ", ";\n  }\n\n  &:active svg path {\n    fill: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
    var n = _ref.$iconPosition;
    return n && "right" === n ? "center" : "flex-start";
  }, h, function (_ref2) {
    var n = _ref2.viewport;
    return "desktop" === n ? x : w;
  }, t.VerizonNHGeDS, y, o(s.letterspacing.wide.value), function (_ref3) {
    var n = _ref3.viewport;
    return "desktop" === n ? k : S;
  }, function (_ref4) {
    var n = _ref4.$colorActive;
    return n;
  }, function (_ref5) {
    var n = _ref5.$colorActive;
    return n;
  }, function (_ref6) {
    var n = _ref6.surface,
      e = _ref6.$colorActiveInverted;
    return "dark" === n && "\n    color: ".concat(v, ";\n    &:active {\n      color: ").concat(e, ";\n    }\n\n    &:active svg path {\n      fill: ").concat(e, ";\n    }\n  ");
  }, function (_ref7) {
    var n = _ref7.disabled;
    return n && "\n    pointer-events: none;\n    cursor: not-allowed;\n    color: ".concat(g, ";\n  ");
  }, function (_ref8) {
    var n = _ref8.disabled,
      e = _ref8.surface;
    return n && "dark" === e && "\n    color: ".concat($, ";\n  ");
  }, function (_ref9) {
    var n = _ref9.surface,
      e = _ref9.$focusRingBorderRadius;
    return "\n     &:focus:not(:hover)  {\n      outline: none;\n      &::before {\n        border: ".concat(o(z), " ").concat(a.focusring.borderstyle.value, " ").concat("dark" === n ? b : m, ";\n        content: '';\n        height: ").concat(A, ";\n        border-radius: ").concat(e, ";\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: ").concat(A, ";\n      }\n    }\n    &:focus:not(:hover):not(:focus-visible) {\n      &:before {\n        display: none; // Only display focus state on keyboard focus, not when radio button is clicked\n      }\n    }\n    &:focus {\n      outline: none;\n    }\n  ");
  }, function (_ref0) {
    var n = _ref0.$iconPosition;
    return " \n      svg {\n        transform: translateX(0);\n        transition: transform ".concat(I, " ").concat(C, ";\n      }\n      &:hover {\n        outline: none;\n      }\n      &:hover svg {\n        position: relative;\n        transform: ").concat("right" === n ? "translateX(4px)" : "translateX(-4px)", ";\n        transition: transform ").concat(C, " ").concat(I, ";\n      }\n\n  ");
  }),
  W = d.span.withConfig({
    displayName: "HitArea",
    componentId: "VDS__sc-o7am1d-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: inline-block;\n  height: ", ";\n  left: 50%;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n"])), V),
  N = d.span.withConfig({
    displayName: "AnchorContentWrapper",
    componentId: "VDS__sc-o7am1d-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  pointer-events: none;\n"]))),
  B = d.span.withConfig({
    displayName: "TextWrapper",
    componentId: "VDS__sc-o7am1d-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  pointer-events: none;\n"]))),
  T = d.span.withConfig({
    displayName: "InlineWrapper",
    componentId: "VDS__sc-o7am1d-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-flex;\n"]))),
  X = d.span.withConfig({
    displayName: "IconWrapper",
    componentId: "VDS__sc-o7am1d-6"
  })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  pointer-events: none;\n  display: inline-flex;\n  position: relative;\n  height: ", ";\n  min-width: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  svg {\n    position: relative;\n    top: ", ";\n  }\n"])), k, G, _, _, function (_ref1) {
    var n = _ref1.$iconPosition;
    return "right" === n ? "5px" : "4px";
  }),
  j = d.div.withConfig({
    displayName: "IconSVGWrapper",
    componentId: "VDS__sc-o7am1d-7"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  min-width: ", ";\n  min-height: ", ";\n  width: ", ";\n  height: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  ", "\n"])), function (_ref10) {
    var n = _ref10.$iconSizeSVG;
    return o(n);
  }, function (_ref11) {
    var n = _ref11.$iconSizeSVG;
    return o(n);
  }, function (_ref12) {
    var n = _ref12.$iconSizeSVG;
    return o(n);
  }, function (_ref13) {
    var n = _ref13.$iconSizeSVG;
    return o(n);
  }, function (_ref14) {
    var n = _ref14.tabIndex;
    return n && n < 0 && "\n  outline: none;\n  pointer-events: none;\n";
  }, function (_ref15) {
    var n = _ref15.$iconColorSVG;
    return u(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    svg {\n      width: ", ";\n      height: ", ";\n      path {\n        fill: ", ";\n      }\n    }\n  "])), function (_ref16) {
      var n = _ref16.$iconSizeSVG;
      return o(n);
    }, function (_ref17) {
      var n = _ref17.$iconSizeSVG;
      return o(n);
    }, n);
  });
function E(n, e) {
  var i = "dark" === e ? v : h;
  return n && (i = "dark" === e ? $ : g), i;
}
function K(n) {
  var e = "";
  return n.forEach(function (i, t) {
    t !== n.length - 1 && (e += "".concat(i, " "));
  }), e;
}
function H(n) {
  var e = n.length - 1,
    i = n[e],
    t = "string" != typeof n[e],
    o = "string" == typeof n,
    r = [];
  if (void 0 === n.length || n.length <= 1) return {
    childArray: [],
    textWithCaret: n
  };
  if (t || !o) return n.forEach(function (n, i) {
    i !== e && (r[i] = n);
  }), {
    childArray: r,
    textWithCaret: i
  };
  var a = n.trim().split(" "),
    l = a[a.length - 1];
  return {
    childArray: K(a),
    textWithCaret: l
  };
}
function M(n, t) {
  var o = n.iconPosition,
    r = n.children,
    a = r ? H(r).childArray : [],
    l = r ? H(r).textWithCaret : "";
  return i(T, {
    role: "text",
    children: ["left" === o && e(X, {
      tabIndex: -1,
      $iconPosition: o,
      "aria-hidden": !0,
      children: e(j, {
        tabIndex: -1,
        "aria-hidden": !0,
        "aria-label": "left-caret-bold icon",
        $iconColorSVG: t,
        $iconSizeSVG: 12,
        children: p
      })
    }), i(N, {
      tabIndex: -1,
      "aria-hidden": !0,
      children: [a, i(B, {
        children: [l, "right" === o && e(X, {
          tabIndex: -1,
          $iconPosition: o,
          "aria-hidden": !0,
          children: e(j, {
            tabIndex: -1,
            "aria-hidden": !0,
            $iconColorSVG: t,
            $iconSizeSVG: 12,
            "aria-label": "right-caret-bold icon",
            children: f
          })
        })]
      })]
    })]
  });
}
var O = function O(t) {
  var o = t.iconPosition,
    r = t.dataLoc,
    a = t.viewport,
    l = t.$focusRingBorderRadius,
    c = t.disabled,
    s = t.tabIndex,
    d = t.role,
    u = t.surface,
    p = t.textLinkCaretRef,
    f = n(t, ["iconPosition", "dataLoc", "viewport", "$focusRingBorderRadius", "disabled", "tabIndex", "role", "surface", "textLinkCaretRef"]),
    h = D(u),
    v = D(u),
    g = "tablet" === a ? "desktop" : a;
  return i(P, Object.assign({}, f, {
    ref: p,
    "data-testid": "TextLinkCaret",
    "data-loc": r,
    href: t.href,
    disabled: t.disabled,
    surface: t.surface,
    viewport: g,
    role: d,
    "aria-disabled": t.disabled,
    "aria-label": t.ariaLabel ? t.ariaLabel : t.children && "string" == typeof t.children ? t.children : "Text Link Caret",
    $iconPosition: o,
    tabIndex: c ? -1 : s || 0,
    $colorActive: h,
    $colorActiveInverted: v,
    $focusRingBorderRadius: l,
    onKeyDown: function onKeyDown(n) {
      t.onKeyDown && t.onKeyDown(n), "Enter" !== n.key && " " !== n.key || t.onClick && t.onClick(n);
    },
    onClick: function onClick(n) {
      t.onClick && t.onClick(n);
    },
    children: [e(W, {
      tabIndex: -1,
      "aria-hidden": !0
    }), e(R, {
      tabIndex: -1,
      "aria-hidden": !0,
      children: M(t, E(t.disabled, t.surface))
    })]
  }));
};
O.defaultProps = {
  viewport: "desktop",
  iconPosition: "right",
  disabled: !1,
  surface: "light",
  role: "link",
  $focusRingBorderRadius: "2px"
};
var q = r(O);
export { q as default };